import Vue from 'vue'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_sentryserver_4de1dc0a from 'nuxt_plugin_sentryserver_4de1dc0a' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_2faf2afc from 'nuxt_plugin_sentryclient_2faf2afc' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_plugin_55867a84 from 'nuxt_plugin_plugin_55867a84' // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_templatesplugin04e3357a_4bdbd678 from 'nuxt_plugin_templatesplugin04e3357a_4bdbd678' // Source: ./templates.plugin.04e3357a.js (mode: 'client')
import nuxt_plugin_clipboard_4dfa12a6 from 'nuxt_plugin_clipboard_4dfa12a6' // Source: ./clipboard.js (mode: 'client')
import nuxt_plugin_nuxtvuexroutersync_50c3bf2e from 'nuxt_plugin_nuxtvuexroutersync_50c3bf2e' // Source: ./nuxt-vuex-router-sync.js (mode: 'all')
import nuxt_plugin_gtm_dbd73ac8 from 'nuxt_plugin_gtm_dbd73ac8' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_dayjsplugin_a5d5c852 from 'nuxt_plugin_dayjsplugin_a5d5c852' // Source: ./dayjs-plugin.js (mode: 'all')
import nuxt_plugin_axios_80c87b74 from 'nuxt_plugin_axios_80c87b74' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_deviceplugin_7007b3d1 from 'nuxt_plugin_deviceplugin_7007b3d1' // Source: ./device.plugin.js (mode: 'all')
import nuxt_plugin_swregisterclient_91e82dd8 from 'nuxt_plugin_swregisterclient_91e82dd8' // Source: ../plugins/sw-register.client.js (mode: 'client')
import nuxt_plugin_vuetinyslider_67155006 from 'nuxt_plugin_vuetinyslider_67155006' // Source: ../plugins/vue-tiny-slider.js (mode: 'client')
import nuxt_plugin_axios_3566aa80 from 'nuxt_plugin_axios_3566aa80' // Source: ../plugins/axios (mode: 'all')
import nuxt_plugin_alert_535fa891 from 'nuxt_plugin_alert_535fa891' // Source: ../plugins/alert.js (mode: 'client')
import nuxt_plugin_tooltip_a5fff1ec from 'nuxt_plugin_tooltip_a5fff1ec' // Source: ../plugins/tooltip.js (mode: 'client')
import nuxt_plugin_index_0c69654a from 'nuxt_plugin_index_0c69654a' // Source: ../plugins/index.js (mode: 'client')
import nuxt_plugin_jsonld_593ee954 from 'nuxt_plugin_jsonld_593ee954' // Source: ../plugins/jsonld (mode: 'all')
import nuxt_plugin_setAppInfo_0c42a3a3 from 'nuxt_plugin_setAppInfo_0c42a3a3' // Source: ../plugins/setAppInfo (mode: 'server')
import nuxt_plugin_gtm_5e4639ea from 'nuxt_plugin_gtm_5e4639ea' // Source: ../plugins/gtm (mode: 'all')
import nuxt_plugin_gtag_0a2cb1e4 from 'nuxt_plugin_gtag_0a2cb1e4' // Source: ../plugins/gtag.js (mode: 'client')
import nuxt_plugin_vueswiper_6a7b4f42 from 'nuxt_plugin_vueswiper_6a7b4f42' // Source: ../plugins/vue-swiper.js (mode: 'all')
import nuxt_plugin_fbConversionAPI_55ccbdb6 from 'nuxt_plugin_fbConversionAPI_55ccbdb6' // Source: ../plugins/fbConversionAPI.js (mode: 'client')
import nuxt_plugin_unitValidate_6cb58272 from 'nuxt_plugin_unitValidate_6cb58272' // Source: ../plugins/unitValidate.js (mode: 'client')
import nuxt_plugin_sentry_e47869fc from 'nuxt_plugin_sentry_e47869fc' // Source: ../plugins/sentry.js (mode: 'all')
import nuxt_plugin_infobip_72a49e72 from 'nuxt_plugin_infobip_72a49e72' // Source: ../plugins/infobip.js (mode: 'all')
import nuxt_plugin_urec_47648034 from 'nuxt_plugin_urec_47648034' // Source: ../plugins/urec.js (mode: 'all')
import nuxt_plugin_eventhub_4210ae3a from 'nuxt_plugin_eventhub_4210ae3a' // Source: ../utils/event-hub.js (mode: 'all')
import nuxt_plugin_vuelazyload_4930ba55 from 'nuxt_plugin_vuelazyload_4930ba55' // Source: ../plugins/vue-lazy-load.js (mode: 'client')
import nuxt_plugin_plugin_0b7d8302 from 'nuxt_plugin_plugin_0b7d8302' // Source: ./auth/plugin.js (mode: 'all')
import nuxt_plugin_auth_8fed78d0 from 'nuxt_plugin_auth_8fed78d0' // Source: ../plugins/auth.js (mode: 'client')
import nuxt_plugin_getquery_5ebcccdb from 'nuxt_plugin_getquery_5ebcccdb' // Source: ../plugins/get-query (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"fade","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp (ssrContext) {
  const router = await createRouter(ssrContext)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  const registerModule = store.registerModule
  store.registerModule = (path, rawModule, options) => registerModule.call(store, path, rawModule, Object.assign({ preserveState: process.client }, options))

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"ecservice_website","titleTemplate":(titleChunk) => {
      return titleChunk ? `${titleChunk} | 智樂家` : '智樂家'
    },"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, viewport-fit=cover"},{"name":"format-detection","content":"telephone=no"},{"hid":"description","name":"description","content":"首選居家生活服務平台-智樂家，線上即可輕鬆預約，提供冷氣、洗衣機清洗、居家打掃等多樣專業到府服務，價格透明不無故加價，萬筆客戶好評，為你解決生活的大小事。"},{"hid":"keywords","name":"keywords","content":"智樂家,居家生活平台,生活服務,家電清洗,冷氣清洗"},{"hid":"robots","name":"robots","content":"all"},{"hid":"googlebot","name":"googlebot","content":"all"},{"hid":"og:type","property":"og:type","content":"website"},{"hid":"og:url","property":"og:url","content":"https:\u002F\u002Fdev.dailypro.com.tw\u002F"},{"hid":"og:title","property":"og:title","content":"智樂家"},{"hid":"og:description","property":"og:description","content":"首選居家生活服務平台-智樂家，線上即可輕鬆預約，提供冷氣、洗衣機清洗、居家打掃等多樣專業到府服務，價格透明不無故加價，萬筆客戶好評，為你解決生活的大小事。"},{"hid":"og:image","property":"og:image","content":"\u002Fdefault-website-preview-image.png"},{"hid":"twitter:card","property":"twitter:card","content":"summary"},{"hid":"twitter:domain","property":"twitter:domain","content":"dev.dailypro.com.tw"},{"hid":"twitter:url","property":"twitter:url","content":"https:\u002F\u002Fdev.dailypro.com.tw\u002F"},{"hid":"twitter:title","property":"twitter:title","content":"智樂家"},{"hid":"twitter:description","property":"twitter:description","content":"首選居家生活服務平台-智樂家，線上即可輕鬆預約，提供冷氣、洗衣機清洗、居家打掃等多樣專業到府服務，價格透明不無故加價，萬筆客戶好評，為你解決生活的大小事。"},{"hid":"twitter:image","property":"twitter:image","content":"\u002Fdefault-website-preview-image.png"},{"hid":"google-site-verification","name":"google-site-verification","content":"mDHmFhqubTM23LN4OIEADhQzBKLFhhJj-wjinoXKF_I"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"}],"script":[{"src":"https:\u002F\u002Fappleid.cdn-apple.com\u002Fappleauth\u002Fstatic\u002Fjsapi\u002Fappleid\u002F1\u002Fen_US\u002Fappleid.auth.js","ssr":false,"async":true,"defer":true},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function (w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e].p&&e[e][p]()))?1:0})(window,'navigator','doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);}})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"htmlAttrs":{"lang":"zh-TW"},"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":""}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  const inject = function (key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Plugin execution

  if (process.server && typeof nuxt_plugin_sentryserver_4de1dc0a === 'function') {
    await nuxt_plugin_sentryserver_4de1dc0a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_2faf2afc === 'function') {
    await nuxt_plugin_sentryclient_2faf2afc(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_55867a84 === 'function') {
    await nuxt_plugin_plugin_55867a84(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_templatesplugin04e3357a_4bdbd678 === 'function') {
    await nuxt_plugin_templatesplugin04e3357a_4bdbd678(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_clipboard_4dfa12a6 === 'function') {
    await nuxt_plugin_clipboard_4dfa12a6(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtvuexroutersync_50c3bf2e === 'function') {
    await nuxt_plugin_nuxtvuexroutersync_50c3bf2e(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_dbd73ac8 === 'function') {
    await nuxt_plugin_gtm_dbd73ac8(app.context, inject)
  }

  if (typeof nuxt_plugin_dayjsplugin_a5d5c852 === 'function') {
    await nuxt_plugin_dayjsplugin_a5d5c852(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_80c87b74 === 'function') {
    await nuxt_plugin_axios_80c87b74(app.context, inject)
  }

  if (typeof nuxt_plugin_deviceplugin_7007b3d1 === 'function') {
    await nuxt_plugin_deviceplugin_7007b3d1(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_swregisterclient_91e82dd8 === 'function') {
    await nuxt_plugin_swregisterclient_91e82dd8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuetinyslider_67155006 === 'function') {
    await nuxt_plugin_vuetinyslider_67155006(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_3566aa80 === 'function') {
    await nuxt_plugin_axios_3566aa80(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_alert_535fa891 === 'function') {
    await nuxt_plugin_alert_535fa891(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_tooltip_a5fff1ec === 'function') {
    await nuxt_plugin_tooltip_a5fff1ec(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_index_0c69654a === 'function') {
    await nuxt_plugin_index_0c69654a(app.context, inject)
  }

  if (typeof nuxt_plugin_jsonld_593ee954 === 'function') {
    await nuxt_plugin_jsonld_593ee954(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_setAppInfo_0c42a3a3 === 'function') {
    await nuxt_plugin_setAppInfo_0c42a3a3(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_5e4639ea === 'function') {
    await nuxt_plugin_gtm_5e4639ea(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gtag_0a2cb1e4 === 'function') {
    await nuxt_plugin_gtag_0a2cb1e4(app.context, inject)
  }

  if (typeof nuxt_plugin_vueswiper_6a7b4f42 === 'function') {
    await nuxt_plugin_vueswiper_6a7b4f42(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_fbConversionAPI_55ccbdb6 === 'function') {
    await nuxt_plugin_fbConversionAPI_55ccbdb6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_unitValidate_6cb58272 === 'function') {
    await nuxt_plugin_unitValidate_6cb58272(app.context, inject)
  }

  if (typeof nuxt_plugin_sentry_e47869fc === 'function') {
    await nuxt_plugin_sentry_e47869fc(app.context, inject)
  }

  if (typeof nuxt_plugin_infobip_72a49e72 === 'function') {
    await nuxt_plugin_infobip_72a49e72(app.context, inject)
  }

  if (typeof nuxt_plugin_urec_47648034 === 'function') {
    await nuxt_plugin_urec_47648034(app.context, inject)
  }

  if (typeof nuxt_plugin_eventhub_4210ae3a === 'function') {
    await nuxt_plugin_eventhub_4210ae3a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuelazyload_4930ba55 === 'function') {
    await nuxt_plugin_vuelazyload_4930ba55(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_0b7d8302 === 'function') {
    await nuxt_plugin_plugin_0b7d8302(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_auth_8fed78d0 === 'function') {
    await nuxt_plugin_auth_8fed78d0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_getquery_5ebcccdb === 'function') {
    await nuxt_plugin_getquery_5ebcccdb(app.context, inject)
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, () => {
        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from, next) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
